import React from 'react';
import PropTypes from 'prop-types';
import FilterBlock from "../../../../components/filter/FilterBlock";
import {Chip, Grid} from "@mui/material";

ShippingMethodFilters.propTypes = {
    shippingMethods: PropTypes.array,
    selectedShippingMethods: PropTypes.array,
    setSelected: PropTypes.func
};

function ShippingMethodFilters({shippingMethods, selectedShippingMethods, setSelected}) {
    return (
        <FilterBlock
            titleId={"retailer.picking.shippingMethodFilter.title"}
        >
            <Grid container columnSpacing={1} rowSpacing={1}>
                {shippingMethods?.map((method) => {
                    if (!method.active) return

                    return (
                        <Grid item>
                            <Chip
                                key={method.id}
                                label={<span style={{ fontWeight: 'bold' }}>{method.name}</span>}
                                variant={"outlined"}
                                color={selectedShippingMethods.includes(method.id) ? "primary" : "default"}
                                isBold
                                onClick={() => {
                                    if (selectedShippingMethods.includes(method.id)) {
                                        setSelected(selectedShippingMethods.filter((id) => id !== method.id));
                                    } else {
                                        setSelected([...selectedShippingMethods, method.id]);
                                    }
                                }}
                            />
                        </Grid>
                    )
                })}
            </Grid>

        </FilterBlock>
    );
}

export default ShippingMethodFilters;